import { render, staticRenderFns } from "./FavoritesDragItems.vue?vue&type=template&id=37bcac32"
import script from "./FavoritesDragItems.vue?vue&type=script&lang=js"
export * from "./FavoritesDragItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports